export const SEARCH_PRODUCTS_BEGIN = 'SEARCH_PRODUCTS_BEGIN';
export const SEARCH_PRODUCTS_FAILURE = 'SEARCH_PRODUCTS_FAILURE';
export const SET_SEARCH_PRODUCTS_VALUE = 'SET_SEARCH_PRODUCTS_VALUE';
export const SET_SEARCH_PRODUCTS_RESULT = 'SET_SEARCH_PRODUCTS_RESULT';
export const RESET_STATE = 'RESET_STATE';
